export default __webpack_public_path__ + "static/media/11-45.70901124.png";